import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import Utils from './plugins/utils'

Vue.use(Utils)

// Axios interceptors for checking session token
import interceptorsSetup from './utils/axiosInterceptors'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
interceptorsSetup()
